import { render, staticRenderFns } from "./MFormSelectMultiple.vue?vue&type=template&id=27928ea2&scoped=true&"
import script from "./MFormSelectMultiple.vue?vue&type=script&lang=js&"
export * from "./MFormSelectMultiple.vue?vue&type=script&lang=js&"
import style0 from "./MFormSelectMultiple.vue?vue&type=style&index=0&id=27928ea2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27928ea2",
  null
  
)

export default component.exports